import { AddOwnerNameResponse, CheckOwnerNameResponse, GetOwnerNameResponse, OwnerPayload } from "./types";

import { NoRecordFound } from "../gql/codeGenCustomTypes.js";
import { clientConfig } from "./clientConfig.js";
import { strings } from "./strings.js";

function createFetchOpts(payload: OwnerPayload) {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  };
}

export const createKey = ({ ownerName, stackFileName }: { ownerName: string; stackFileName: string }) => {
  return `${ownerName}/${stackFileName}`;
};

// atomically claims the owner name for the firebase account behind the jwt.
// success: false + message tells you why (name taken, user already has a name, …);
// networkError: true means the request itself failed.
export async function addOwnerName({ owner, jwt, turnstileToken }:
  {
    owner: string,
    jwt: string,
    turnstileToken: string
  }
): Promise<{ success: boolean; message?: string; networkError?: boolean }> {
  const payload: OwnerPayload = { owner, jwt, turnstileToken };
  try {
    const req = await fetch(`${clientConfig.users()}/register`, createFetchOpts(payload));
    const res: AddOwnerNameResponse = await req.json();
    return { success: res.success, message: res.message };
  } catch (error) {
    console.error(error)
    return { success: false, networkError: true };
  }
}

// advisory availability lookup — /register is the authority, so a name can
// still be lost between check and register (surface the register error then)
export async function checkOwnerName(
  owner: string,
): Promise<{ success: boolean; message?: string; networkError?: boolean }> {
  const payload: OwnerPayload = { owner };
  try {
    const req = await fetch(`${clientConfig.users()}/check`, createFetchOpts(payload));
    const res: CheckOwnerNameResponse = await req.json();
    return { success: res.success, message: res.message };
  } catch (error) {
    console.log(error)
    return { success: false, networkError: true };
  }
}

export async function getOwnerName(
  jwt: string,
): Promise<{ success: boolean | typeof strings.messages.error; owners?: string[] }> {
  const payload: OwnerPayload = { jwt };
  try {

    const req = await fetch(`${clientConfig.users()}/owners`, createFetchOpts(payload));
    const res: GetOwnerNameResponse = await req.json();
    return { success: res.success, owners: res.owners, };
  } catch (error) {
    console.log(error)
    return { success: false };
  }
}

export const noRecordFound: NoRecordFound = {
  success: false,
  message: strings.utility.noRecordFound,
};




